import { render, staticRenderFns } from "./CustomersExternalCheck.vue?vue&type=template&id=4bfe255d"
import script from "./CustomersExternalCheck.vue?vue&type=script&lang=js"
export * from "./CustomersExternalCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports